import { useModal } from '@aloft/toolkit-sui';

import { CertifyModalInternal } from '../CertifyModalInternal.tsx';

export const useCertifyModal = () => {
  const { Modal, openModal, isModalOpen, closeModal } = useModal();

  const CertifyModal = isModalOpen ? (
    <CertifyModalInternal
      Modal={Modal}
      closeModal={closeModal}
      isModalOpen={isModalOpen}
    />
  ) : null;

  return { certifyModal: CertifyModal, openCertifyModal: openModal };
};
